<template>
  <div
    id="accordion"
    role="tablist"
    class="w-100 mb-2 rounded mb-4"
    :class="[!isOpen && 'bg-gray']"
  >
    <div class="d-flex align-items-center justify-content-between">
      <b-button
        class="d-flex justify-content-between align-items-center fw-medium"
        block
        :class="[
          isOpen ? 'text-primary' : 'text-black',
          isOpen && stores ? 'w-50' : 'w-100',
        ]"
        v-b-toggle="title"
        variant="ghost"
      >
        {{ title }}
        <b-icon v-if="!isOpen" variant="primary" icon="chevron-right" />
      </b-button>
      <div v-if="isOpen && stores" class="d-flex align-items-center">
        Selecionar Todos
        <input
          type="checkbox"
          class="checkbox-stores"
          @click="$emit('selectAll')"
        />
      </div>
    </div>

    <b-collapse :id="title" accordion="my-accordion" v-model="isOpen">
      <b-card-body class="p-0 cp-main">
        <slot />
      </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Accordion",
  props: {
    title: {
      type: String,
      require: true,
    },
    stores: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: ref(this.open),
    };
  },
};
</script>

<style>
.visible {
  visibility: visible;
}

.not-visible {
  visibility: hidden;
}

.bg-gray {
  background-color: #f0f2f8;
}

.checkbox-stores {
  height: 1.1rem;
  width: 1.1rem;
  font-size: 1.1rem;
  border-color: #c3cbd9;
  margin-left: 12px;
  margin-right: 15px;
}

.cp-main {
  max-height: 200px;
  overflow-y: auto;
}
</style>
